<template>
    <div class="row align-items-md-stretch" v-if="flash.success">
        <div class="col-12">
            <div class="alert alert-success" role="alert">
                {{ flash.success }}
            </div>
        </div>
    </div>
    <div class="row align-items-md-stretch pb-5">
        <div class="col-md-6" v-if="cek_sekolah">
            <div class="h-100 p-5 bg-light border rounded-3">
                <h2>Pilih Sekolah</h2>
                <form @submit.prevent="submit">
                    <div class="input-group">
                        <select :class="{ 'form-select': true, 'is-invalid': errors.sekolah_id ? true : false }"
                            aria-label="Default select example" v-model="form.sekolah_id" aria-describedby="sekolah_id">
                            <option selected :value="null">== Pilih Sekolah ==</option>
                            <option v-for="s in sekolah" :key="s.sekolah_id" :value="s.sekolah_id">{{ s.nama }}</option>
                        </select>
                        <button class="btn btn-outline-secondary" type="submit">Simpan</button>
                        <div v-if="errors.sekolah_id" id="sekolah_id" class="invalid-feedback">{{ errors.sekolah_id }}
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div :class="{ 'col-md-6': cek_sekolah ? true : false, 'col-12': cek_sekolah ? false : true }">
            <div class="h-100 p-5 bg-light border rounded-3">
                <h2>Cari Data PTK</h2>
                <form @submit.prevent="submitPtk">
                    <div class="input-group">
                        <input type="text" :class="{ 'form-control': true, 'is-invalid': errors.nik ? true : false }"
                            aria-describedby="nik" placeholder="Masukkan NIK" aria-label="Recipient's username"
                            v-model="form.nik">
                        <button class="btn btn-outline-secondary" type="submit" :disabled="isDisabled">
                            <template v-if="isDisabled">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Loading...
                            </template>
                            <template v-else>
                                Cari...
                            </template>
                        </button>
                        <div v-if="errors.nik" id="nik" class="invalid-feedback">{{ errors.nik }}</div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div class="row align-items-md-stretch pb-5" v-if="flash.nik">
        <div class="col-md-5">
            <div class="h-100 p-5 bg-light border rounded-3">
                <h2>Hasil Pencarian</h2>
                <template v-if="flash.ptk">
                    <table class="table table-bordered">
                        <tr>
                            <td>Nama</td>
                            <td>{{ flash.ptk.nama }}</td>
                        </tr>
                        <tr>
                            <td>NIK</td>
                            <td>{{ flash.ptk.nik }}</td>
                        </tr>
                        <tr>
                            <td>NUPTK</td>
                            <td>{{ flash.ptk.nuptk }}</td>
                        </tr>
                        <tr>
                            <td>Tempat, Tanggal Lahir</td>
                            <td>{{ flash.ptk.tempat_lahir }}, {{ flash.ptk.tanggal_lahir }}</td>
                        </tr>
                        <tr>
                            <td>Nama Ibu Kandung</td>
                            <td>{{ flash.ptk.nama_ibu_kandung }}</td>
                        </tr>
                    </table>
                </template>
                <template v-else>
                    <p>NIK tidak ditemukan!</p>
                </template>
            </div>
        </div>
        <div class="col-md-7">
            <div class="h-100 p-5 bg-light border rounded-3">
                <h2>Riwayat PTK Terdaftar</h2>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <td class="text-center">Nama Sekolah</td>
                            <td class="text-center">NPSN</td>
                            <td class="text-center">Tahun</td>
                            <td class="text-center">Jenis Keluar</td>
                            <td class="text-center">Tanggal Keluar</td>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="flash.ptk">
                            <tr v-for="(reg, index) in flash.ptk.terdaftar" :key="reg.ptk_terdaftar_id">
                                <td>{{ reg.sekolah.nama }}</td>
                                <td class="text-center">{{ reg.sekolah.npsn }}</td>
                                <td class="text-center">{{ reg.tahun_ajaran_id }}</td>
                                <td class="text-center">{{ jenis_keluar(reg.jenis_keluar_id) }}</td>
                                <td class="text-center">{{ reg.tgl_ptk_keluar }}</td>
                            </tr>
                        </template>
                        <template v-else>
                            <tr>
                                <td class="text-center" colspan="4">Tidak ada data untuk ditampilkan</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import Main from "@/Layouts/Main.vue";
export default {
    layout: Main,
    props: {
        auth: Object,
        errors: Object,
        sekolah: Array,
        user: Object,
        ptk: Object,
        flash: Object,
        jenis_pendaftaran: Array,
    },
    data() {
        return {
            form: this.$inertia.form({
                sekolah_id: null,
                nik: null,
            }),
            errors: {
                sekolah_id: null,
                nik: null,
            },
            options: this.sekolah,
            isDisabled: false,
            cek_sekolah: this.sekolah.length ? true : false,
        }
    },
    mounted() {
        this.$store.dispatch("setAuth", this.auth);
    },
    created() {
        this.form.sekolah_id = this.auth.user.sekolah_id
    },
    methods: {
        submit() {
            this.form['post'](this.route("dashboard.store"), {
                onError: (errors) => {

                    if (Object.entries(errors).length !== 0) {
                        var toast = {
                            bg: "bg-danger",
                        };

                        if (errors.hasOwnProperty("sekolah_id")) {
                            toast.message = errors.sekolah_id;
                            this.errors.sekolah_id = errors.sekolah_id;
                        }
                    }
                },
                onSuccess: () => {
                    this.errors.sekolah_id = null
                }
            });
        },
        submitPtk() {
            this.isDisabled = true
            this.form['post'](this.route("dashboard.guru"), {
                onError: (errors) => {
                    this.isDisabled = false
                    console.log(errors);
                    if (Object.entries(errors).length !== 0) {
                        var toast = {
                            bg: "bg-danger",
                        };

                        if (errors.hasOwnProperty("nik")) {
                            toast.message = errors.nik;
                            this.errors.nik = errors.nik;
                        }
                    }
                },
                onSuccess: () => {
                    this.isDisabled = false
                    this.errors.nik = null
                }
            });
        },
        jenis_keluar(id) {
            var data = {
                "1": "Lulus",
                "2": "Mutasi",
                "3": "Dikeluarkan",
                "4": "Mengundurkan diri",
                "5": "Putus Sekolah",
                "6": "Wafat",
                "7": "Hilang",
                "8": "Alih Fungsi",
                "9": "Pensiun",
                "Z": "Lainnya",
            }
            if (id) {
                return data[id];
            }
        }
    },
};
</script>
